import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import {
  getPetAssetKey,
  Species,
  speciesAssetsRatio,
  speciesChatbot,
} from './species';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';
import { buildSender } from '../sender';

/**
 * Assets for fullenergy messages
 */
export const fullenergyAssets = {
  'background/fullenergy': 'private/chatbot/energy/fullenergy_background.jpg',
  'text/fullenergy/ja': 'private/chatbot/energy/fullenergy_text_ja.png',
};

/**
 * Create fullenergy message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const fullenergyMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    locale: SB.tuple(['en', 'ja']),
    petName: SB.string(),
  }),
  (data, payload, api) => {
    const altText = getLocaleConfig(data.locale).energy.full.text;
    const icon: Species = api.getAssetPath(
      getPetAssetKey(data.species),
    ) as Species;

    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath('background/fullenergy'),
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1.51:1',
            gravity: 'center',
          },
          {
            type: 'box',
            layout: 'vertical',
            position: 'absolute',
            width: '100%',
            height: '70%',
            offsetBottom: '32%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: icon,
                    aspectRatio: speciesAssetsRatio[icon],
                    aspectMode: 'fit',
                    position: 'absolute',
                    gravity: 'bottom',
                    align: 'center',
                    size: 'full',
                  },
                ],
                position: 'absolute',
                width: '35%',
                height: '100%',
                justifyContent: 'flex-end',
                alignItems: 'center',
              },
            ],
          },
          {
            type: 'box',
            layout: 'vertical',
            position: 'absolute',
            width: '100%',
            height: '30%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: api.getAssetPath('text/fullenergy/ja'),
                    aspectRatio: '6.5:1',
                    aspectMode: 'fit',
                    position: 'absolute',
                    gravity: 'bottom',
                    align: 'center',
                    size: 'full',
                  },
                ],
                position: 'absolute',
                width: '100%',
                height: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '8px',
                paddingStart: '10px',
              },
            ],
          },
        ],
        paddingAll: '0px',
      },
    });

    // Add sender to message
    template['sender'] = buildSender({ name: data.petName, iconUrl: icon });

    return template;
  },
);
